import * as React from "react";
const sizes = {
    xs: 16,
    sm: 20,
    md: 20,
    lg: 24,
    xl: 36,
};
function SvgArrowLeft(props) {
    return (React.createElement("svg", Object.assign({ width: sizes[props.size || "lg"], height: sizes[props.size || "lg"], viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M10.2853 5.7032C10.6758 5.31268 10.6758 4.67951 10.2853 4.28899C9.89479 3.89846 9.26162 3.89846 8.87109 4.28899L2.59006 10.5817C1.80901 11.3627 1.80901 12.6291 2.59006 13.4101L8.87745 19.7055C9.26797 20.096 9.90115 20.096 10.2917 19.7055C10.6822 19.3149 10.6822 18.6818 10.2917 18.2912L5.00389 13H21C21.5523 13 22 12.5522 22 12C22 11.4477 21.5523 11 21 11H5.00389L10.2853 5.7032Z", fill: "currentColor" })));
}
export default SvgArrowLeft;
